module.exports = __webpack_public_path__ + "static/media/avatar-trio.8d6fa860.svg";